import React from "react";
import BondDocumentUploadBase from "../../shared/components/BondDocumentUploadBase";
import { TRUSTEE_DOCUMENT_UPLOAD_SECTIONS } from "../../shared/documentUploadConfig";

const DocumentUpload = (props) => (
  <BondDocumentUploadBase
    {...props}
    sections={TRUSTEE_DOCUMENT_UPLOAD_SECTIONS}
    fileNameDisplay="legacy"
  />
);

export default DocumentUpload;
